import { Navigate, Route } from "react-router";
import PatientBalanceRedirect from "@/packages/patientBalance/components/PatientBalanceRedirect";
import {
  PATIENT_CHOICE_PROGRAM,
  PATIENT_ENERGY_BALANCE,
  PATIENT_NEW_PROGRAM,
  PATIENT_PROGRAM_DAYS,
  PATIENT_PROGRAM_DAY_DIET_EDIT,
  PATIENT_PROGRAM_DAY_DIET_EDIT_PRODUCTS,
  PATIENT_PROGRAM_DAY_DIET_EDIT_RECIPES,
  PATIENT_PROGRAM_DAY_DIET_EDIT_SETTINGS,
  PATIENT_PROGRAM_DAY_DIET_EDIT_TAGS,
  PATIENT_PROGRAM_DAY_DIET_NEW,
  PATIENT_PROGRAM_EDIT,
  PATIENT_PROGRAM_EDIT_ASSUMPTIONS,
  PATIENT_PROGRAM_EDIT_MEAL_PLAN,
  PATIENT_PROGRAM_EDIT_RECIPES,
  PATIENT_PROGRAM_EDIT_SCHEDULE,
  PATIENT_PROGRAM_EDIT_SETTINGS,
  PATIENT_PROGRAM_SCHEDULE,
  PATIENT_PROGRAM_SCHEDULE_RECIPE_EDIT,
  PATIENT_START_PROGRAM,
} from "@routes/routes";
import {
  ClientProgramSchedulePage,
  DietCreatorPage,
  DietCreatorProductsPage,
  DietCreatorRecipesPage,
  DietCreatorSettingsPage,
  DietCreatorTagsPage,
  PatientProgramChoicePage,
  PatientProgramDaysPage,
  ProgramAssumptionsPage,
  ProgramCreatorBootstrapPage,
  ProgramCreatorPage,
  ProgramCreatorSchedulePage,
  ProgramDietsNewPage,
  ProgramMealPlanPage,
  ProgramRecipesPage,
  ProgramSettingsPage,
  ScheduleRecipeEditPage,
  PatientProgramDay,
  StartCollaborationPage,
  PatientProgramLayoutPage,
} from "@routes/lazyPages";

/** A program assigned to a patient. */
export const patientProgramRoutes = (
  <>
    <Route lazy={PatientProgramLayoutPage}>
      <Route path={PATIENT_START_PROGRAM} lazy={StartCollaborationPage} />
      <Route path={PATIENT_CHOICE_PROGRAM} lazy={PatientProgramChoicePage} />
      <Route path={PATIENT_PROGRAM_DAY_DIET_NEW} lazy={ProgramDietsNewPage} />
      <Route path={PATIENT_PROGRAM_DAYS} lazy={PatientProgramDaysPage}>
        <Route path=":dayId" lazy={PatientProgramDay} />
      </Route>
      <Route
        path={PATIENT_ENERGY_BALANCE}
        element={<PatientBalanceRedirect />}
      />
      <Route path={PATIENT_PROGRAM_DAY_DIET_EDIT} lazy={DietCreatorPage}>
        <Route
          path={PATIENT_PROGRAM_DAY_DIET_EDIT_SETTINGS}
          lazy={DietCreatorSettingsPage}
        />
        <Route
          path={PATIENT_PROGRAM_DAY_DIET_EDIT_RECIPES}
          lazy={DietCreatorRecipesPage}
        />
        <Route
          path={PATIENT_PROGRAM_DAY_DIET_EDIT_PRODUCTS}
          lazy={DietCreatorProductsPage}
        />
        <Route
          path={PATIENT_PROGRAM_DAY_DIET_EDIT_TAGS}
          lazy={DietCreatorTagsPage}
        />
      </Route>
      {}
      <Route path={PATIENT_NEW_PROGRAM} lazy={ProgramCreatorBootstrapPage} />
      <Route path={PATIENT_PROGRAM_EDIT} lazy={ProgramCreatorPage}>
        {}
        <Route index element={<Navigate to="settings" replace />} />
        <Route
          path={PATIENT_PROGRAM_EDIT_SETTINGS}
          lazy={ProgramSettingsPage}
        />
        <Route
          path={PATIENT_PROGRAM_EDIT_ASSUMPTIONS}
          lazy={ProgramAssumptionsPage}
        />
        <Route path={PATIENT_PROGRAM_EDIT_RECIPES} lazy={ProgramRecipesPage} />
        <Route
          path={PATIENT_PROGRAM_EDIT_MEAL_PLAN}
          lazy={ProgramMealPlanPage}
        />
        <Route
          path={PATIENT_PROGRAM_EDIT_SCHEDULE}
          lazy={ProgramCreatorSchedulePage}
        />
      </Route>
      <Route path={PATIENT_PROGRAM_SCHEDULE} lazy={ClientProgramSchedulePage} />
      <Route
        path={PATIENT_PROGRAM_SCHEDULE_RECIPE_EDIT}
        lazy={ScheduleRecipeEditPage}
      />
    </Route>
  </>
);
